/**
 * time interval for time dropdown in minutes
 */
export const TIME_INTERVAL_MINS = 15;

/**
 * Time threshold to allow signing a note before the session end time
 */
export const NOTE_SIGN_TIME_THRESHOLD = 15 * 60 * 1000;